import {
  TranslationAlertMessages,
  AlertMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAlertMessages = {
  [AlertMessages.noPermissionInvoices]: "Você não possui nenhum cliente permitido para visualizar faturas.",
  [AlertMessages.noPermissionCreditLimit]: "Você não possui nenhum cliente permitido para visualizar limite de crédito.",
  [AlertMessages.noPermissionCertificates]: "Você não possui nenhum cliente permitido para visualizar laudos.",
  [AlertMessages.noPermissionConcretingRequest]: "Você não possui permissão de solicitação em nenhum cliente.",
  [AlertMessages.noPermissionInvoicesSpecificClient]: "Você não possui permissão para visualizar faturas deste cliente.",
  [AlertMessages.noPermissionCreditLimitSpecificClient]: "Você não possui permissão para visualizar limite de crédito deste cliente.",
  [AlertMessages.noPermissionCertificatesSpecificClient]: "Você não possui permissão para visualizar laudos deste cliente.",
  [AlertMessages.noPermissionConcretingRequestSpecificClient]: "Você não possui permissão de solicitação neste cliente.",
  [AlertMessages.noHaveInvoices]: "Você ainda não possui nenhuma fatura para visualizar.",
  [AlertMessages.noHaveCertificates]: "Você ainda não possui nenhum laudo para visualizar.",
  [AlertMessages.noHaveInvoicesSpecificClient]: "Este cliente ainda não possui faturas para visualizar.",
  [AlertMessages.noHaveCertificatesSpecificClient]: "Este cliente ainda não possui laudos para visualizar.",
  [AlertMessages.noHaveConcretingRequestSpecificClient]: "Este cliente ainda não possui solicitações para visualizar.",
  [AlertMessages.noConcretingApproval]: "Nenhuma aprovação de programação para visualizar.",
  [AlertMessages.noConcreting]: "Nenhuma programação para visualizar.",
  [AlertMessages.noContract]: "Nenhum contrato para visualizar.",
  [AlertMessages.noUser]: "Nenhum usuário para visualizar."
};
